import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import {
  ACKNOWLEDGE_MINIHUB_TUTORIAL,
  LOAD_MINI_HUB,
  LOOKUP_MGMT_CODE,
  RESET_MGMT_CODE_LOOKUP,
  SET_RELOAD_FLAG
} from '../actions/miniHub'
import { handleRest, initialRestState, restReducer } from '../h2Api'
import { LOAD_HOME_TUTORIAL } from '../actions/tutorials'
import { REQUEST_MGMT_BY_CODE } from '../actions/editPersonalProfile'

const codeRequest = (state = initialRestState(), action) => {
  switch (action.type) {
    case RESET_MGMT_CODE_LOOKUP:
      console.log('CLEAR', initialRestState())

      return initialRestState()
    case LOOKUP_MGMT_CODE:
      const newCodeState = handleRest(action, {}, state)

      console.log(newCodeState)

      return newCodeState
    default:
      return state
  }
}
const initialTutorialState = {
  sawTutorial: true
}
const tutorialReducer = (state = initialTutorialState, action) => {
  switch (action.type) {
    case ACKNOWLEDGE_MINIHUB_TUTORIAL:
      return {
        ...state,
        sawTutorial: action.isAcknowledged
      }
    default:
      return state
  }
}
const miniHubState = {
  requireReload: false
}
const miniHubStateReducer = (state = miniHubState, action) => {
  switch (action.type) {
    case SET_RELOAD_FLAG:
      return {
        ...state,
        requireReload: action.newState
      }
    default:
      return state
  }
}

export default combineReducers({
  tutorial: tutorialReducer,
  miniprops: miniHubStateReducer,
  tutorialRequest: restReducer(LOAD_HOME_TUTORIAL),
  userData: restReducer(LOAD_MINI_HUB),
  mgmtCodeRequest: restReducer(REQUEST_MGMT_BY_CODE),
  codeRequest,
  forms: combineForms(
    {
      lookupCode: {
        code: ''
      }
    },
    'miniHub.forms'
  )
})
